<template>
  <div>
    <div class="row" style="height: 60px"></div>
    <div class="row titleRow">
      <div class="col">
        <h1>{{$t('config.general.title')}}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <form-wizard ref="formwizard"
                     title=""
                     subtitle=""
                     :startIndex="$store.state.config.stepFilled"
                     :backButtonText="$t('general.back')"
                     :nextButtonText="$t('general.next')"
                     :finishButtonText="$t('general.save')"
                     stepSize="sm"
                     :color="$store.state.config.mainconfig.bgColor"
                     shape="circle"
                     @on-complete="onCompleteWizard"
                     @on-change="onChangeWizard"
                     :validateOnBack="true"
        >
          <tab-content :title="$t('config.steps.design')">
            <div class="row">
              <div class="col-md-4 col-xs-12">
                <h3>{{$t('config.design.color')}}</h3>
                <sketch-picker v-model="design.colors" @input="handleColorChange"/>
                <button type="submit" style="margin-top: 20px" class="btn btn-primary">{{$t('config.design.buttonNoSelected')}}</button>
                <button type="submit" style="margin-top: 20px" class="btn btn-primary bg-color">{{$t('config.design.buttonSelected')}}</button>
              </div>
              <div class="col-md-4 col-xs-12">
                <h3>{{$t('config.design.logo')}}</h3>
                <picture-input
                  v-if="hackInputPictureResize === true"
                  ref="logoInput"
                  id="logoImage"
                  :prefill="$store.state.config.mainconfig.logo"
                  :prefillOptions="{fileType: 'png'}"
                  @change="customizeLogo('add')"
                  @remove="customizeLogo('delete')"
                  width="600"
                  height="600"
                  margin="16"
                  accept="image/png"
                  :removable=true
                  size="10"
                  buttonClass="btn"
                  removeButtonClass="btn removeLogo"
                  :customStrings="{
        upload: $t('config.design.outdatedDevice'),
        drag: $t('config.design.dragLogo'),
        change: '',
        remove: '',
      }">
                </picture-input>
                <pulse-loader :loading="isLogoUploaded" ></pulse-loader>
              </div>
              <div class="col-md-4 col-xs-12">
                <h3>{{$t('config.design.background')}}</h3>
                <picture-input
                  v-if="hackInputPictureResize === true"
                  ref="backgroundInput"
                  id="backgroundImage"
                  :prefill="$store.state.config.mainconfig.background"
                  :prefillOptions="{fileType: 'jpg'}"
                  @change="customizeBackground('add')"
                  @remove="customizeBackground('delete')"
                  width="600"
                  height="600"
                  margin="16"
                  accept="image/jpeg"
                  :removable=true
                  size="10"
                  buttonClass="btn"
                  removeButtonClass="btn removeBackground"
                  :customStrings="{
        upload: $t('config.design.outdatedDevice'),
        drag: $t('config.design.dragImage'),
        change: '',
        remove: '',
      }">              </picture-input>
                <pulse-loader :loading="isBackgroundUploaded" ></pulse-loader>
              </div>
            </div>
          </tab-content>
          <tab-content :title="$t('config.steps.cgv')">
          <vue-editor id="cgv" v-model="cgv" :editorToolbar="customToolbar"></vue-editor>
        </tab-content>
          <tab-content :title="$t('config.steps.prices')" :beforeChange="handleTabWizardChange" active>
            <b-tabs>
              <b-tab :title="$t('config.prices.insurance.title')" :disabled="errorValidationForm">
                <form id="insurance" class="needs-validation" accept-charset="utf-8" novalidate>
                  <div class="form-row">
                    <div class="form-group col-md-2 verticalCenter">
                      <p style="display: contents;text-align: left"><em>{{$t('config.general.active')}}</em></p>
                    </div>
                    <div class="form-group col-md-2">
                      <label class="switch">
                        <input :value="prices.insurance.active" @change="updatePrices('insurance', 'active', $event.target.checked);" type="checkbox" :checked="prices.insurance.active">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div>
                  <div v-show="prices.insurance.active" class="form-row">
                    <div class="form-group col-md-4">
                      <label>{{$t('config.general.name')}}</label>
                      <input type="text" @blur="checkValidityForm('insurance', true, false)" :value="prices.insurance.name" v-on:keyup.stop="updatePrices('insurance', 'name', $event.target.value)" :class="'form-control ' + ((prices.insurance.name !== '') ? 'filledForm' : '')" required>
                      <div class="invalid-feedback">
                        {{$t('config.offers.formsValidation.noName')}}
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label>{{$t('config.general.price')}}</label>
                      <input type="number" min="0" step="0.01" @blur="checkValidityForm('insurance', true, false)" :value="prices.insurance.price" @change="updatePrices('insurance', 'price', $event.target.value)" :class="'form-control ' + ((prices.insurance.price !== '') ? 'filledForm' : '')" required>
                      <div class="invalid-feedback">
                        {{$t('config.offers.formsValidation.noPrice')}}
                      </div>
                    </div>
                  </div>
                </form>
              </b-tab>

              <b-tab :title="$t('config.prices.smoothedIncrease.title')" :disabled="errorValidationForm">
                <form id="smoothIncrease" class="needs-validation" accept-charset="utf-8" novalidate>
                  <div class="form-row">
                    <div class="form-group col-md-2 verticalCenter">
                      <p style="display: contents;text-align: left"><em>{{$t('config.general.active')}}</em></p>
                    </div>
                    <div class="form-group col-md-2">
                      <label class="switch">
                        <input :value="prices.smoothIncrease.active" @change="updatePrices('smoothIncrease', 'active', $event.target.checked);" type="checkbox" :checked="prices.smoothIncrease.active">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div>
                  <div v-show="prices.smoothIncrease.active" class="form-row">
                    <div class="form-group col-md-2">
                      <label>{{$t('config.general.price')}}</label>
                      <input type="number" min="0" step="0.01" @blur="checkValidityForm('smoothIncrease', prices.smoothIncrease.active, false)" :value="prices.smoothIncrease.price" @change="updatePrices('smoothIncrease', 'price', $event.target.value)" :class="'form-control ' + ((prices.smoothIncrease.price !== '') ? 'filledForm' : '')" required>
                      <div class="invalid-feedback">
                        {{$t('config.offers.formsValidation.noPrice')}}
                      </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label>{{$t('config.general.duration')}}</label>
                      <input type="number" min="0" @blur="checkValidityForm('smoothIncrease', prices.smoothIncrease.active, false)" :value="prices.smoothIncrease.duration" @change="updatePrices('smoothIncrease', 'duration', $event.target.value)" :class="'form-control ' + ((prices.smoothIncrease.duration !== '') ? 'filledForm' : '')" required>
                      <div class="invalid-feedback">
                        {{$t('config.offers.formsValidation.noDuration')}}
                      </div>
                    </div>
                    <div class="form-group col-md-8">
                      <div class="row">
                        <div class="col">
                      <label>{{$t('config.prices.smoothedIncrease.commitment')}}</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <label class="clickableItem"><input type="radio" name="commitment" value="week" @change="updatePrices('smoothIncrease', 'commitment', $event.target.value)" :checked="prices.smoothIncrease.commitment == 'week'" required/> {{$tc('config.commitments.week', (prices.smoothIncrease.duration > 1) ? 2 : 1)}}</label>
                        </div>
                        <div class="col">
                          <label class="clickableItem"><input type="radio" name="commitment" value="month" @change="updatePrices('smoothIncrease', 'commitment', $event.target.value)" :checked="prices.smoothIncrease.commitment == 'month'"/> {{$tc('config.commitments.month')}}</label>
                        </div>
                        <div class="col">
                          <label class="clickableItem"><input type="radio" name="commitment" value="year" @change="updatePrices('smoothIncrease', 'commitment', $event.target.value)" :checked="prices.smoothIncrease.commitment == 'year'"/> {{$tc('config.commitments.year', (prices.smoothIncrease.duration > 1) ? 2 : 1)}}</label>
                        </div>
                        </div>
                  </div>
                  </div>
                </form>
              </b-tab>

              <b-tab :title="$t('config.prices.employedPackages.title')" :disabled="errorValidationForm">
                <form id="employedPackages" class="needs-validation" accept-charset="utf-8" novalidate>
                  <div class="form-row">
                    <div class="form-group col-md-2 verticalCenter">
                      <p style="display: contents;text-align: left"><em>{{$t('config.general.active')}}</em></p>
                    </div>
                    <div class="form-group col-md-2">
                      <label class="switch">
                        <input :value="prices.employedPackages.active" @change="updatePrices('employedPackages', 'active', $event.target.checked);" type="checkbox" :checked="prices.employedPackages.active">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div>
                  <div v-show="prices.employedPackages.active" class="form-row">
                    <div class="form-group col-md-4">
                      <label>{{$t('config.general.name')}}</label>
                      <input type="text" @blur="checkValidityForm('employedPackages', prices.employedPackages.active, false)" :value="prices.employedPackages.name" v-on:keyup.stop="updatePrices('employedPackages', 'name', $event.target.value)" :class="'form-control ' + ((prices.employedPackages.name !== '') ? 'filledForm' : '')" required>
                      <div class="invalid-feedback">
                        {{$t('config.offers.formsValidation.noName')}}
                      </div>
                    </div>
                    <div class="form-group col-md-2">
                      <label>{{$t('config.general.price')}}</label>
                      <input type="number" min="0" step="0.01" @blur="checkValidityForm('employedPackages', prices.employedPackages.active, false)" :value="prices.employedPackages.price" @change="updatePrices('employedPackages', 'price', $event.target.value)" :class="'form-control ' + ((prices.employedPackages.price !== '') ? 'filledForm' : '')" required>
                      <div class="invalid-feedback">
                        {{$t('config.offers.formsValidation.noPrice')}}
                      </div>
                    </div>
                  </div>
                  <div v-show="prices.employedPackages.active" class="form-row">
                    <div class="form-group col-md-2">
                      <label>{{$t('config.general.duration')}}</label>
                      <input type="number" min="0" @blur="checkValidityForm('employedPackages', prices.employedPackages.active, false)" :value="prices.employedPackages.duration" @change="updatePrices('employedPackages', 'duration', $event.target.value)" :class="'form-control ' + ((prices.employedPackages.duration !== '') ? 'filledForm' : '')" required>
                      <div class="invalid-feedback">
                        {{$t('config.offers.formsValidation.noDuration')}}
                      </div>
                    </div>
                    <div class="form-group col-md-10">
                      <div class="row">
                        <div class="col">
                          <label>{{$t('config.prices.smoothedIncrease.commitment')}}</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <label class="clickableItem"><input type="radio" name="commitment" value="week" @change="updatePrices('employedPackages', 'commitment', $event.target.value)" :checked="prices.employedPackages.commitment == 'week'"/> {{$tc('config.commitments.week', (prices.employedPackages.duration > 1) ? 2 : 1)}}</label>
                        </div>
                        <div class="col">
                          <label class="clickableItem"><input type="radio" name="commitment" value="month" @change="updatePrices('employedPackages', 'commitment', $event.target.value)" :checked="prices.employedPackages.commitment == 'month'"/> {{$t('config.commitments.month')}}</label>
                        </div>
                        <div class="col">
                          <label class="clickableItem"><input type="radio" name="commitment" value="year" @change="updatePrices('employedPackages', 'commitment', $event.target.value)" :checked="prices.employedPackages.commitment == 'year'"/> {{$tc('config.commitments.year', (prices.employedPackages.duration > 1) ? 2 : 1)}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </b-tab>
            </b-tabs>
          </tab-content>
          <tab-content :title="$t('config.steps.commitments')" :beforeChange="handleTabWizardChange">
            <div class="row">
              <div class="col-md-6">
                <form id="commitments" class="needs-validation" accept-charset="utf-8" novalidate>
                  <div class="form-row">
                    <div class="form-group col-md-5">
                      <label>{{$t('config.general.name')}}</label>
                      <input type="text" class="form-control" v-model="commitmentsConfig.name" required>
                    </div>
                    <div class="form-group col-md-5">
                      <label>{{$t('config.general.duration') + ' (' +$t('config.commitments.in') + ' ' + $t('config.commitments.month').toLowerCase() + ")"}}</label>
                      <input type="number" min="0" class="form-control" v-model="commitmentsConfig.duration" required/>
                    </div>
                    <div style="margin-top: auto; margin-bottom: auto;" class="form-group col-md-2">
                    <button type="submit" class="btn btn-primary" @click="addRow(commitments, 'commitments', commitmentsConfig, {name: commitmentsConfig.name, duration: commitmentsConfig.duration})"><i class="fas fa-plus"></i></button>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-md-6">
                <b-table striped :items="commitments" :fields="commitmentsConfig.fields">
                  <span slot="name" slot-scope="data">
                    <input name="defaultCommitment" type="radio" style="float: left;  margin-top: 5px;" @click="$store.dispatch('config/CONFIG_SAVEDATA', {['defaultCommitment'] : data.item.duration})" :checked="$store.state.config.defaultCommitment === data.item.duration" :title="($store.state.config.defaultCommitment === data.item.duration) ? 'Période par défaut' : 'Définir comme période par défaut'">
                    {{data.value}}
                  </span>
                  <span slot="actions" slot-scope="data">
                    <a href="javascript:;" @click="deleteRow(commitments, 'commitments', data.index)" style="margin-right: 10px;"><i class="fas fa-trash-alt"></i></a>
                  </span>
                </b-table>
              </div>
            </div>
          </tab-content>
          <tab-content :title="$t('config.steps.options')" :beforeChange="handleTabWizardChange">
            <div class="row">
              <div class="col-md-6">
                <form id="options" class="needs-validation" accept-charset="utf-8" novalidate>
                  <div class="form-row">
                    <div class="form-group col-md-5">
                      <label>{{$t('config.general.name')}}</label>
                      <input type="text" class="form-control" v-model="optionsConfig.name" required>
                    </div>
                    <div class="form-group col-md-5">
                      <label>{{$t('config.general.price')}}</label>
                      <input type="number" min="0" step="0.01" class="form-control" v-model="optionsConfig.price"/>
                    </div>
                    <div style="margin-top: auto; margin-bottom: auto;" class="form-group col-md-2">
                      <button type="submit" class="btn btn-primary" @click="addRow(options, 'options', optionsConfig, {id: optionsConfig.id, name: optionsConfig.name, price: optionsConfig.price})"><i class="fas fa-plus"></i></button>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-md-6">
                <b-table striped :items="options" :fields="optionsConfig.fields" >
                  <span slot="actions" slot-scope="row">
                    <a href="javascript:;" @click="deleteRow(options, 'options', row.index)"><i class="fas fa-trash-alt"></i></a>
                  </span>
                  <span slot="price" slot-scope="data">
                  {{(data.value) ? data.value : $t('config.options.noprices') }}
                  </span>
                </b-table>
              </div>
            </div>
          </tab-content>
          <tab-content :title="$t('config.steps.offers')" :beforeChange="handleTabWizardChange">
            <div class="row">
              <div class="col-md-12">
                <b-card no-body>
                  <b-tabs card v-model="offerIndex">
                    <!-- Render Tabs -->
                    <b-tab v-for="(offer, i) in offers" :key="i">
                      <template slot="title">
                        {{offer.name}} <a href="javascript:;" class='deleteOffer' :title="$t('config.offers.delete')" @click="deleteOffer(i)"><i class="fas fa-trash-alt"></i></a>
                      </template>
                      <form id="offers" class="needs-validation" accept-charset="utf-8" novalidate>
                        <div class="form-row">
                          <div class="form-group col-md-5">
                            <label>{{$t('config.general.name')}}</label>
                            <input type="text" class="form-control" :value="offer.name" @keyup="updateOffers(i, null, 'name', $event.target.value);" required>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-md-12">
                            <div class="row">
                              <div class="col">
                                <label>{{$t('config.offers.paymentPeriod')}}</label>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <label class="clickableItem"><input type="radio" name="recurrentTime" value="week" @change="updateOffers(i, null, 'recurrentTime', 'week')" :checked="offer.recurrentTime == 'week'"/> {{$tc('config.commitments.week', 1)}}</label>
                              </div>
                              <div class="col">
                                <label class="clickableItem"><input type="radio" name="recurrentTime" value="month" @change="updateOffers(i, null, 'recurrentTime', 'month')" :checked="offer.recurrentTime == 'month'"/> {{$t('config.commitments.month')}}</label>
                              </div>
                              <div class="col">
                                <label class="clickableItem"><input type="radio" name="recurrentTime" value="year" @change="updateOffers(i, null, 'recurrentTime', 'year')" :checked="offer.recurrentTime == 'year'"/> {{$tc('config.commitments.year', 1)}}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-row" v-show="offersConfig.commitments.length !== 0 && offersConfig.commitments[i].length == 1 && offersConfig.commitments[i][0].duration == 0">
                          <div class="form-group col-md-12">
                            <div class="row">
                              <div class="col">
                                <label>{{$t('config.offers.commitmentTime')}}</label>
                             </div>
                            </div>
                              <div class="row">
                                <div class="col-md-3">
                                <input type="number" min="0" :value="offer.commitment.duration" @change="updateOffers(i, 'commitment', 'duration', $event.target.value)" :class="'form-control ' + ((offer.commitment.duration !== '') ? 'filledForm' : '')" :required="offersConfig.commitments.length !== 0 && offersConfig.commitments[i].length == 1 && offersConfig.commitments[i][0].duration == 0">
                                <div class="invalid-feedback">
                                  {{$t('config.offers.formsValidation.noDuration')}}
                                </div>
                              </div>
                              <div class="col">
                                <div class="row">
                                  <div class="col">
                                    <label class="clickableItem"><input type="radio" name="commitment" value="week" @change="updateOffers(i, 'commitment', 'period', 'week')" :checked="offer.commitment.period == 'week'"/> {{$tc('config.commitments.week', (offer.commitment.duration > 1) ? 2 : 1)}}</label>
                                  </div>
                                  <div class="col">
                                    <label class="clickableItem"><input type="radio" name="commitment" value="month" @change="updateOffers(i, 'commitment', 'period', 'month')" :checked="offer.commitment.period == 'month'"/> {{$t('config.commitments.month')}}</label>
                                  </div>
                                  <div class="col">
                                    <label class="clickableItem"><input type="radio" name="commitment" value="year" @change="updateOffers(i, 'commitment', 'period', 'year')" :checked="offer.commitment.period == 'year'"/> {{$tc('config.commitments.year', (offer.commitment.duration > 1) ? 2 : 1)}}</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-md-12">
                            <label>{{$t('config.general.periods')}}</label>
                            <b-table striped :items="offersConfig.commitments[i]" :fields="offersConfig.fields" >
                               <span slot="initialPrice" slot-scope="data" >
                                <input type="number" min="0" step="0.01" :value="data.value" @keyup="updateOffers(i, 'initialPrice', data.item.duration, $event.target.value);"/>
                               </span>
                              <span slot="recurrentPrice" slot-scope="data">
                                <input type="number" min="0" step="0.01" :value="data.value" @keyup="updateOffers(i, 'recurrentPrice', data.item.duration, $event.target.value);" />
                               </span>
                            </b-table>
                          </div>
                          </div>
                        <div class="form-row">
                          <div class="form-group col-md-6">
                            <h3>{{$t('config.offers.activityList')}}</h3>
                            <draggable :v-model="getOptionFromOffer(i)" class="dragArea" :options="{group:'options'}" @add="addedOptionInOffer">
                              <div v-for="(option, index) in getOptionFromOffer(i)" :key="index" :data-offer="i" :data-id="option.id"><div v-b-toggle="'accordion'+index" class="btn btn-danger optionDraggable bg-color">{{getOptionElement(option.id).name}}<span class="deleteOptionFromOffer"><a href="javascript:;" @click="removeOption(i, option.id)"><i class="fas fa-trash-alt"></i></a></span></div>
                              <b-collapse :id="'accordion'+index" :visible="option.price == ''" accordion="my-accordion" role="tabpanel">
                                <form id="optionsInOffers" class="needs-validation" accept-charset="utf-8" novalidate>
                                  <div class="form-row">
                                    <div class="form-group col-md-5">
                                      <label>{{$t('config.general.price')}}</label>
                                      <input type="number" min="0" step="0.01" class="form-control" :value="$store.state.config.offers[i].options[index].price" @change="updateOptionsInOffer(index, $event.target.value)"/>
                                    </div>
                                  </div>
                                </form>
                              </b-collapse>
                              </div>
                            </draggable>
                          </div>
                          <div class="col-md-6">
                            <h3>{{$t('config.offers.activityAvailable')}}</h3>
                            <draggable v-model="options" :options="{group:{ name:'options',  pull:'clone', put:false }}" @start="drag=true" @end="drag=false" :clone="clonedOption" :move="onMoveCallback">
                              <div v-for="option in options" class="btn btn-danger optionDraggable" :key="option.id">{{option.name}}</div>
                            </draggable>
                          </div>
                        </div>
                      </form>

                    </b-tab>

                    <b-nav-item slot="tabs" @click.prevent="addOffer" href="#">
                      +
                    </b-nav-item>

                    <!-- Render this if no tabs -->
                    <div slot="empty" class="text-center text-muted">
                      <span v-html="$t('config.offers.nooffers')"></span>
                    </div>
                  </b-tabs>
                </b-card>
              </div>
            </div>
          </tab-content>
          <tab-content :title="$t('config.steps.knowus')" :beforeChange="handleTabWizardChange">
            <p>{{$t('config.knowus.title')}}</p>
            <div v-for="i in Math.ceil((knowus.list.length)/3)" :key="i" class="row listOfButtons">
              <div v-for="(item, index) in knowus.list.slice((i-1)*3, (i-1)*3+3)" :key="index" class="col">
                <button :class="'btn btn-secondary ' + ((knowus.selectedItems.indexOf(item)) !== -1 ? 'bg-color' : '')" @click="addItem(item, 'knowus')">{{knowus.i18nList[item]}}</button>
              </div>
            </div>
          </tab-content>
          <tab-content :title="$t('config.steps.target')" :beforeChange="handleTabWizardChange">
            <p>{{$t('config.target.title')}}</p>
            <div v-for="i in Math.ceil((target.list.length)/3)" :key="i" class="row listOfButtons">
              <div v-for="(item, index) in target.list.slice((i-1)*3, (i-1)*3+3)" :key="index" class="col">
                <button :class="'btn btn-secondary ' + ((target.selectedItems.indexOf(item)) !== -1 ? 'bg-color' : '')" @click="addItem(item, 'target')">{{target.i18nList[item]}}</button>
              </div>
            </div>
          </tab-content>
          <tab-content :title="$t('config.steps.other')" :beforeChange="handleTabWizardChange">
            <form id="other" class="needs-validation" accept-charset="utf-8" novalidate>
              <div class="form-row">
                <div class="form-group col-md-4 verticalCenter">
                  <p style="display: contents;text-align: left"><em>{{$t('config.other.activeSurprise')}}</em></p>
                </div>
                <div class="form-group col-md-2">
                  <label class="switch">
                    <input  v-model="activeSurprise" type="checkbox">
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
            </form>
              <label style="display: contents">{{$t('config.other.starterPack')}}</label>
            <vue-editor id="starterPack" v-model="starterPack" :editorToolbar="customToolbar"></vue-editor>
          </tab-content>
        </form-wizard>
      </div>
    </div>
  </div>
</template>

<script>
import { Sketch } from 'vue-color';
import Hue from 'vue-color/src/components/common/Hue';
import PictureInput from 'vue-picture-input';
import bTabs from 'bootstrap-vue/es/components/tabs/tabs';
import bTab from 'bootstrap-vue/es/components/tabs/tab';
import bTable from 'bootstrap-vue/es/components/table/table';
import bCard from 'bootstrap-vue/es/components/card/card';
import bNavItem from 'bootstrap-vue/es/components/nav/nav-item';
import draggable from 'vuedraggable';
import bCollapse from 'bootstrap-vue/es/components/collapse/collapse';
import vBToggle from 'bootstrap-vue/es/directives/toggle/toggle';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
export default {
  name: 'Configuration',
  components: {
    Hue,
    'sketch-picker': Sketch,
    'picture-input': PictureInput,
    'b-tabs': bTabs,
    'b-tab': bTab,
    'b-table': bTable,
    'b-card': bCard,
    'b-nav-item': bNavItem,
    'draggable': draggable,
    'b-collapse': bCollapse,
    'pulse-loader': PulseLoader
  },
  directives: {
    'b-toggle': vBToggle
  },
  deactivated: function () {
    this.hackInputPictureResize = false;
  },
  activated: function () {
    this.hackInputPictureResize = this.$refs.formwizard.activeTabIndex === 0; // On active l'affichage des pictures input seulement si on est sur le bon onglet de la configuration
  },
  mounted: function () {
    // if (this.$store.getters['config/isConfigOk']) { // On vérifie si une configuration existe et est valide
    //   this.$refs.formwizard.activateAll() // On active les steps déjà renseignés
    // }

    // On constuit le tableau de période pour chaque pack
    if (this.$store.state.config.offers.length !== 0) {
      for (let offer in this.$store.state.config.offers) {
        this.offersConfig.commitments.push(this.getCommitmentArray(offer));
      }
    }
    // MOYENS DE CONNAISSANCE //
    if (this.$store.state.config.knowus.length !== 0) { // On sélectionne les moyens de connaissance précédemment configurés
      this.knowus.selectedItems = [...this.$store.state.config.knowus];
    } else { // Si rien n'a encore été configuré, on les pré sélectionne tous
      this.knowus.selectedItems = [...this.knowus.list];
      this.$store.dispatch('config/CONFIG_SAVEDATA', {knowus: [...this.knowus.list]}); // Puis on sauvegarde la configuration
    }
    // // OBJECTIF //
    if (this.$store.state.config.target.length !== 0) { // On sélectionne les objectifs précédemment configurés
      this.target.selectedItems = [...this.$store.state.config.target];
    } else { // Si rien n'a encore été configuré, on les pré sélectionne tous
      this.target.selectedItems = [...this.target.list];
      this.$store.dispatch('config/CONFIG_SAVEDATA', {target: [...this.target.list]}); // Puis on sauvegarde la configuration
    }
  },
  data () {
    return {
      errorValidationForm: false,
      offerIndex: 0,
      hackInputPictureResize: true, // Cette variable permet de corriger le problème d'affichage des picture inputs en cas de resize de la fenêtre.
      isLogoUploaded: false,
      isBackgroundUploaded: false,
      knowus: {
        list: ['promo', 'walkIn', 'advertising', 'sponsor', 'internet', 'flyers', 'pubtruck', 'oldmember', 'kakemono', 'other'],
        i18nList: {
          promo: this.$t('knowUs.promo'),
          walkIn: this.$t('knowUs.walkIn'),
          advertising: this.$t('knowUs.advertising'),
          sponsor: this.$t('knowUs.sponsor'),
          internet: this.$t('knowUs.internet'),
          flyers: this.$t('knowUs.flyers'),
          pubtruck: this.$t('knowUs.pubtruck'),
          oldmember: this.$t('knowUs.oldmember'),
          kakemono: this.$t('knowUs.kakemono'),
          other: this.$t('knowUs.other')
        },
        selectedItems: []
      },
      target: {
        list: ['weightloss', 'fitness', 'zen', 'relaxation', 'bodybuilding'],
        i18nList: {
          weightloss: this.$t('target.weightloss'),
          fitness: this.$t('target.fitness'),
          zen: this.$t('target.zen'),
          relaxation: this.$t('target.relaxation'),
          bodybuilding: this.$t('target.bodybuilding')
        },
        selectedItems: []
      },
      design: {
        colors: (this.$store.state.config.mainconfig.bgColor) ? this.$store.state.config.mainconfig.bgColor : '#85C33F',
        logo: this.$store.state.config.mainconfig.logo,
        background: this.$store.state.config.mainconfig.background
      },
      prices: {...this.$store.state.config.prices},
      commitmentsConfig: {
        name: '',
        duration: '',
        fields: [
          {
            key: 'name',
            label: this.$t('config.general.name')
          },
          {
            key: 'duration',
            label: this.$t('config.general.duration')
          },
          {
            key: 'actions',
            label: this.$t('config.general.actions')
          }
        ]
      },
      commitments: [...this.$store.state.config.commitments],
      optionsConfig: {
        id: new Date().getTime(),
        name: '',
        price: '',
        fields: [
          {
            key: 'name',
            label: this.$t('config.general.name')
          },
          {
            key: 'price',
            label: this.$t('config.general.price')
          },
          {
            key: 'actions',
            label: this.$t('config.general.actions')
          }
        ]
      },
      offersConfig: {
        commitments: [],
        fields: [
          {
            key: 'period',
            label: this.$t('config.general.periods')
          },
          {
            key: 'initialPrice',
            label: this.$t('config.offers.initialPrice')
          },
          {
            key: 'recurrentPrice',
            label: this.$t('config.offers.recurrentPrice')
          }
        ]
      },
      optionToAdd: null,
      customToolbar: [
        [{ 'header': [ false, 1, 2, 3, 4, 5, 6 ] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{'align': ''}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
        ['blockquote'],
        [{'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
        [{'indent': '-1'}, { 'indent': '+1' }],
        [{'color': []}, { 'background': [] }],
        ['link', 'image']]
    };
  },
  methods: {
    handleColorChange (color) {
      this.$setNewAppColor(color.hex);
      this.$store.dispatch('config/CONFIG_SETCOLOR', color.hex);
    },
    uploadFile (filename, base64) {
      return this.$http.put('file/moduleVente/' + filename,
        {
          content: base64
        });
    },
    deleteFile (filename) {
      return this.$http.delete('file/moduleVente/' + filename);
    },
    customizeBackground (action) {
      switch (action) {
        case 'add':
          this.isBackgroundUploaded = true;
          this.uploadFile('background.jpg', this.$refs.backgroundInput.image).then((resp) => {
            this.$store.dispatch('config/CONFIG_SETBACKGROUND', resp.data.url);
            this.$store.dispatch('config/CONFIG_UPLOADCONFIG', this.$store.state.user.token);
            this.isBackgroundUploaded = false;
            // eslint-disable-next-line
          }).catch((err) => {
            document.getElementsByClassName('removeBackground')[0].click();
            this.$notify({type: 'error', title: this.$t('general.errorApi.generalTitle'), text: this.$t('general.errorApi.addImage.errormsg')});
            this.isBackgroundUploaded = false;
            this.$sentry.captureExceptionWithTags(err, {action: action}, this.$options.name, 'customizeBackground');
          });
          break;
        case 'delete':
          if (this.$store.state.config.mainconfig.background !== '') {
            this.deleteFile('background.jpg').then((resp) => {
              this.$store.dispatch('config/CONFIG_SETBACKGROUND', '');
              this.$store.dispatch('config/CONFIG_UPLOADCONFIG', this.$store.state.user.token);
              // eslint-disable-next-line
            }).catch((err) => {
              this.$notify({
                type: 'error',
                title: this.$t('general.errorApi.generalTitle'),
                text: this.$t('general.errorApi.removeImage.errormsg')
              });
              this.$sentry.captureExceptionWithTags(err, {action: action}, this.$options.name, 'customizeBackground');
            });
          }
          break;
      }
    },
    customizeLogo (action) {
      switch (action) {
        case 'add':
          this.isLogoUploaded = true;
          this.uploadFile('logo.png', this.$refs.logoInput.image).then((resp) => {
            this.$store.dispatch('config/CONFIG_SETLOGO', resp.data.url);
            this.$store.dispatch('config/CONFIG_UPLOADCONFIG', this.$store.state.user.token);
            this.isLogoUploaded = false;
            // eslint-disable-next-line
          }).catch((err) => {
            document.getElementsByClassName('removeLogo')[0].click();
            this.$notify({type: 'error', title: this.$t('general.errorApi.generalTitle'), text: this.$t('general.errorApi.addImage.errormsg')});
            this.isLogoUploaded = false;
            this.$sentry.captureExceptionWithTags(err, {action}, this.$options.name, 'customizeLogo');
          });
          break;
        case 'delete':
          if (this.$store.state.config.mainconfig.logo !== '') {
            this.deleteFile('logo.png').then((resp) => {
              this.$store.dispatch('config/CONFIG_SETLOGO', '');
              this.$store.dispatch('config/CONFIG_UPLOADCONFIG', this.$store.state.user.token);
              // eslint-disable-next-line
            }).catch((err) => {
              this.$notify({
                type: 'error',
                title: this.$t('general.errorApi.generalTitle'),
                text: this.$t('general.errorApi.removeImage.errormsg')
              });
              this.$sentry.captureExceptionWithTags(err, {action}, this.$options.name, 'customizeLogo');
            });
          }
          break;
      }
    },
    onChangeWizard (prevIndex, nextIndex) {
      this.hackInputPictureResize = nextIndex === 0; // Toujours le même hack pour que le resize de la fenêtre ne casse pas l'affichage des picture input
      if (nextIndex > prevIndex) {
        this.$store.dispatch('config/CONFIG_SAVESTEPFILLED', nextIndex);
        this.$store.dispatch('config/CONFIG_UPLOADCONFIG', this.$store.state.user.token); // On sauvegarde la configuration en bdd dès qu'on change de step
      } else {
        this.errorValidationForm = false;
      }
    },
    handleTabWizardChange () {
      switch (this.$refs.formwizard.activeTabIndex) {
        case 2: // Les prix
          if (!this.checkValidityForm('insurance', this.prices.insurance.active, false) || !this.checkValidityForm('smoothIncrease', this.prices.smoothIncrease.active, false) || !this.checkValidityForm('employedPackages', this.prices.employedPackages.active, false)) {
            this.errorValidationForm = true;
          }
          break;
        case 4: // les options
          if (this.options.length === 0) { // Une option minimum est requise pour pouvoir configurer les offres
            this.errorValidationForm = true;
            this.$notify({type: 'error', title: this.$t('general.errorApi.generalTitle'), text: this.$t('config.options.nooption')});
          }
          break;
        case 5: // les offres
          if (this.offers.length === 0) { // Une offre minimum est requise
            this.errorValidationForm = true;
            this.$notify({type: 'error', title: this.$t('general.errorApi.generalTitle'), text: this.$t('config.offers.nooffers')});
          } else {
            this.checkValidityForm('offers', true, false);
          }
          break;
      }

      return !this.errorValidationForm;
    },
    onCompleteWizard () {
      this.$store.dispatch('config/CONFIG_TOGGLECONFIGMODE');
    },
    addItem (item, data) {
      switch (data) {
        case 'knowus':
          var i = this.knowus.selectedItems.indexOf(item);
          if (i === -1) {
            this.knowus.selectedItems.push(item);
          } else {
            this.knowus.selectedItems.splice(i, 1);
          }
          this.$store.dispatch('config/CONFIG_SAVEDATA', {knowus: [...this.knowus.selectedItems]});
          break;
        case 'target':
          i = this.target.selectedItems.indexOf(item);
          if (i === -1) {
            this.target.selectedItems.push(item);
          } else {
            this.target.selectedItems.splice(i, 1);
          }
          this.$store.dispatch('config/CONFIG_SAVEDATA', {target: [...this.target.selectedItems]});
          break;
      }
    },
    updatePrices (field, subfield, value) {
      this.$store.dispatch('config/CONFIG_SETPRICES', {field, subfield, value});
      // Si on désactive un formulaire, on passe la variable de gestion des erreurs à false car il n'y a plus de vérif à faire sur ce formulaire
      if (this.errorValidationForm && subfield === 'active' && !value) {
        this.errorValidationForm = false;
      } else if (!this.errorValidationForm && subfield === 'active' && value) { // Si on réactive un formulaire, on vérifie s'il est correct
        this.checkValidityForm(field, true, false);
      }
    },
    checkValidityForm (formId, validate, justPrintError) {
      let form = document.getElementById(formId);
      if (form) {
        if (validate) {
          form.classList.add('was-validated');
          this.errorValidationForm = !form.checkValidity();
          return !this.errorValidationForm;
        } else if (justPrintError) {
          form.classList.add('was-validated');
          return form.checkValidity();
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    addRow (tab, tabId, tabConfig, content) {
      if (this.checkValidityForm(tabId, false, true)) { // Si on a bien le nom de l'option, on l'ajoute au tableau
        tab.push(content);
        if (tabId === 'commitments') { // on gère le tableau qui contient les prix des packs en fonction des périodes d'engagement
          if (this.$store.state.config.commitments.length === 0) { // C'est la première période qu'on rajoute ! On la met en période par défaut
            this.$store.dispatch('config/CONFIG_SAVEDATA', {'defaultCommitment': tabConfig['duration']});
          }
          for (let offer in this.offersConfig.commitments) {
            // Si un prix par défaut a été défini pour un pack, il faut le supprimer !
            if (this.offersConfig.commitments[offer][0].duration !== undefined && this.offersConfig.commitments[offer][0].duration === 0) {
              this.offersConfig.commitments[offer].splice(0, 1);
            }

            this.offersConfig.commitments[offer].push(
              {
                period: tabConfig['name'],
                duration: tabConfig['duration'],
                initialPrice: '',
                recurrentPrice: ''
              });
          }
        } else if (tabId === 'options') {
          this.errorValidationForm = false; // Si on rajoute au moins une option, on n'est plus dans un cas d'erreur
        }
        for (let config in tabConfig) {
          if (config !== 'fields' && config !== 'id') { // On réinitialise le form pour l'ajout d'une nouvelle ligne
            tabConfig[config] = '';
          }
          if (config === 'id') {
            tabConfig[config] = new Date().getTime();
          }
        }
        this.$store.dispatch('config/CONFIG_SAVEDATA', {[tabId]: [...tab]});
      }
    },
    deleteRow (tab, tabId, index) {
      switch (tabId) {
        case 'commitments': // on gère le tableau qui contient les prix des packs en fonction des périodes d'engagement
          if (tab.length !== 1 && this.$store.state.config.defaultCommitment === this.$store.state.config.commitments[index].duration) {
            this.$store.dispatch('config/CONFIG_SAVEDATA', {'defaultCommitment': this.$store.state.config.commitments[(index !== 0) ? 0 : 1].duration});
          }
          for (let offer in this.offersConfig.commitments) {
            this.offersConfig.commitments[offer].splice(index, 1);
            // Si toutes les périodes d'engagements sont supprimées, on rajoute le prix par défaut
            if (tab.length === 1) { // === 1 car on supprime la ligne après ce if ! Donc quand il ne reste qu'un item dans le tableau, il sera vide à la fin de l'exécution de cette méthode
              this.offersConfig.commitments[offer].push(
                {
                  period: this.$t('config.offers.defaultPrice'),
                  duration: 0,
                  initialPrice: this.$store.state.config.offers[offer].initialPrice['0'],
                  recurrentPrice: this.$store.state.config.offers[offer].recurrentPrice['0']
                });
            }
          }
          break;
        case 'options' : // On supprime les options ajouté aux packs
          for (let offer in this.offers) {
            this.removeOption(offer, tab[index].id);
          }
          break;
      }
      tab.splice(index, 1);
      this.$store.dispatch('config/CONFIG_SAVEDATA', {[tabId]: [...tab]});
    },
    deleteOffer (index) {
      this.offers.splice(index, 1);
      this.offersConfig.commitments.splice(index, 1);
      if (this.offerIndex === index && index !== 0) { // Si on supprime une offre, il faut afficher l'offre précédente
        this.offerIndex--;
      }
      this.$store.dispatch('config/CONFIG_SAVEDATA', {offers: [...this.offers]});
    },
    addOffer () {
      this.offers.push({
        name: this.$t('config.offers.defaultName'),
        initialPrice: {},
        recurrentPrice: {},
        recurrentTime: 'month',
        commitment: {
          period: 'month',
          duration: ''
        },
        options: []
      });
      this.$store.dispatch('config/CONFIG_SAVEDATA', {offers: [...this.offers]});
      this.offersConfig.commitments.push(this.getCommitmentArray(this.offers.length - 1));
      this.errorValidationForm = false; // Si on rajoute au moins une offre, on n'est plus dans un cas d'erreur
    },
    updateOffers (index, field, subfield, value) {
      if (field === 'initialPrice' || field === 'recurrentPrice') { // On modifie le prix d'un pack ! Il faut mettre à jour le tableau local
        for (let commitment in this.offersConfig.commitments[index]) { // on parcourt les périodes d'engagements
          if (this.offersConfig.commitments[index][commitment].duration === subfield) { // On modifie le prix qui vient d'être modifié
            this.offersConfig.commitments[index][commitment][field] = value;
          }
        }
      }
      this.$store.dispatch('config/CONFIG_SETOFFER', {index, field, subfield, value});
    },
    getCommitmentArray (offer) {
      let arrayCommitment = [];
      if (this.$store.state.config.commitments.length !== 0) { // On construit le tableau selon les périodes d'engagement définies
        for (let commitment in this.$store.state.config.commitments) {
          arrayCommitment.push({
            period: this.$store.state.config.commitments[commitment].name,
            duration: this.$store.state.config.commitments[commitment].duration,
            initialPrice: this.$store.state.config.offers[offer].initialPrice[this.$store.state.config.commitments[commitment].duration],
            recurrentPrice: this.$store.state.config.offers[offer].recurrentPrice[this.$store.state.config.commitments[commitment].duration]
          });
        }
      } else { // Si aucune période d'engagement n'est définie
        arrayCommitment.push({
          period: this.$t('config.offers.defaultPrice'),
          duration: 0,
          initialPrice: this.$store.state.config.offers[offer].initialPrice['0'],
          recurrentPrice: this.$store.state.config.offers[offer].recurrentPrice['0']
        });
      }
      return arrayCommitment;
    },
    onMoveCallback (evt, originalEvent) {
      let optionAlreadyAdded = document.querySelectorAll("[data-offer='" + this.offerIndex + "'][data-id='" + evt.draggedContext.element.id + "']"); // On cherche si l'option n'existe pas déjà pour ce pack
      if (optionAlreadyAdded !== null && optionAlreadyAdded.length > 0) { // Si l'option a déjà été ajoutée pour ce pack, on fige le drag & drop de l'option
        return false;
      }
    },
    removeOption (offerIndex, idOption) {
      let options = [...this.$store.state.config.offers[offerIndex].options];
      options.every(function (opt, index) {
        if (opt.id !== idOption) {
          return true;
        } else {
          options.splice(index, 1);
          this.$store.dispatch('config/CONFIG_SETOFFER', {index: offerIndex, field: null, subfield: 'options', value: options});
          return false;
        }
      }, this);
    },
    updateOptionsInOffer (optionIndex, value) {
      let options = [...this.$store.state.config.offers[this.offerIndex].options];
      let option = {...options[optionIndex]};
      option.price = value;
      options[optionIndex] = option;
      this.$store.dispatch('config/CONFIG_SETOFFER', {index: this.offerIndex, field: null, subfield: 'options', value: options});
    },
    getOptionFromOffer (offerIndex) {
      return this.$store.state.config.offers[offerIndex].options;
    },
    addedOptionInOffer (evt) {
      let options = [...this.$store.state.config.offers[this.offerIndex].options];
      options.push(this.optionToAdd);
      this.$store.dispatch('config/CONFIG_SETOFFER', {index: this.offerIndex, field: null, subfield: 'options', value: options});
    },
    clonedOption (original) {
      let formatedOption = {...original};
      delete formatedOption.name;
      formatedOption.active = true; // Pour le moment, toutes les options ajoutées sont activées pour le pack
      this.optionToAdd = formatedOption;
      return formatedOption;
    },
    getOptionElement (id) {
      let option = null;
      this.options.every(function (opt) {
        if (opt.id !== id) {
          return true;
        } else {
          option = opt;
          return false;
        }
      });
      return option;
    }
  },
  computed: {
    offers: function () {
      return [...this.$store.state.config.offers];
    },
    options: function () {
      return [...this.$store.state.config.options];
    },
    activeSurprise: {
      get: function () {
        return this.$store.state.config.activeSurprise;
      },
      set: function (value) {
        this.$store.dispatch('config/CONFIG_SAVEDATA', {activeSurprise: value});
      }
    },
    cgv: { // #TODO parserconfig.commitments.week les cgv à la recherche d'image en base64 pour faire un call à l'API pour upload l'image et récuperer l'url où elle est hébergée.
      get: function () {
        return this.$store.state.config.cgv;
      },
      set: function (value) {
        this.$store.dispatch('config/CONFIG_SAVEDATA', {cgv: value});
      }
    },
    starterPack: {
      get: function () {
        return this.$store.state.config.starterPack;
      },
      set: function (value) {
        this.$store.dispatch('config/CONFIG_SAVEDATA', {starterPack: value});
      }
    }
  }

};
</script>

<style>
h3 {
  text-align: center;
  font-size: 1.1em !important;
}
.vc-sketch {
  margin-right: auto;
  margin-left: auto;
  width: 80% !important;
}
.picture-input .btn {
    display: none;
    position: absolute;
    width: 20%;
    height: 20%;
    bottom: 30%;
    z-index: 99999;
    border-radius: 100px;
    background-color: transparent !important;
    border-color: transparent !important;
    transition: all 0.2s;
}
.picture-input .btn:hover {
  transform: scale(1.3) ;
}
.picture-input .btn:nth-child(2) {
  background: url('../../../static/img/edit.png') no-repeat center center ;
  background-size: 60%;
  left: 25%
}
.picture-input .btn:nth-child(3) {
  background: url('../../../static/img/delete.png') no-repeat center center ;
  background-size: 60%;
  right: 25%
}
.picture-input {
  position: relative;
  z-index: 1;
}
.picture-input:hover {
  background: rgba(120, 120, 120, 0.1);
}
.picture-input:hover .picture-preview{
  opacity: 0.1;
}
.picture-input:hover .picture-inner {
  opacity: 0.5;
}
.picture-input:hover .btn {
  display: block;
}
.ql-editor {
  max-height: 26em;
}
.btn {
  font-size: 1em !important;
 }
.vc-sketch-presets {
  display: none;
}
.vnis {
  display: inline-flex;
}
.optionDraggable {
  display: block;
  position: relative;
  border: 1px solid black !important;
}
.optionDraggable .deleteOptionFromOffer {
  display: none;
}
.optionDraggable:hover .deleteOptionFromOffer {
  display: block;
}
.dragArea {
  min-height: 100px;
  background-color: lightgray;
}
.deleteOptionFromOffer {
  position: absolute;
  bottom: 0;
  right: 0;
}
.nav-link .deleteOffer {
  display: none;
}
.nav-link:hover .deleteOffer {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/layouts/config/Configuration.vue